<template>
    <div>+
        <div class="row">
            <div class="col-md-10 offset-md-1">
                <router-link class="btn btn-primary btn-block" :to="{ name: 'ContactAdd' }">
                    {{$t('contacts.addModalQR.back')}}
                </router-link>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <qrcode-reader @init="onInit" @decode="onDecode"/>
            </div>
        </div>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';

export default {
    data: function () {
        return {
            cameraLoading: true,
            cameraError: '',
        }
    },
    computed: mapGetters({
        loading: 'loading/loading/loading',
    }),
    methods: {
        onDecode: function (tokenUrl) {
            if (tokenUrl) {
                let token = tokenUrl.substr(tokenUrl.lastIndexOf('/') + 1);
                this.$store.dispatch('contact/pair/useToken', token).then(() => {
                    this.$router.push({name: 'ContactAdded'})
                }).catch(() => {});
            }
        },
        onInit: async function (promise) {
            try {
                await promise
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                    this.cameraError = 'contacts.addModalQR.error.cameraNotGranted';
                } else if (error.name === 'NotFoundError') {
                    this.cameraError = 'contacts.addModalQR.error.cameraNotFound';
                } else if (error.name === 'NotSupportedError') {
                    this.cameraError = 'contacts.addModalQR.error.cameraNotSupported';
                } else if (error.name === 'NotReadableError') {
                    this.cameraError = 'contacts.addModalQR.error.cameraInUse';
                } else {
                    this.cameraError = 'contacts.addModalQR.error.unknown';
                }
            } finally {
                this.cameraLoading = false;
            }
        },
    },
    created() {
        this.$store.dispatch('contact/pair/reset')
    },
};
</script>


// WEBPACK FOOTER //
// src/components/contact/PairQRReader.vue